<template>
    <div>

        <router-link :to="'/rental-history/' + rental.id" tag="div" class="ph3 ph4-ns hover-bg-near-white pv3 bb b--light-gray pointer" v-for="(rental, index) in rentals" :key="index">
            <div class="formLabel mid-gray mb1">{{rental.startDate | moment("MMMM DD, YYYY")}}</div>
            <div class="flex items-center">
                <div class="mr3 ba b--light-gray">
                <img class="w3 h3 w4-ns h4-ns" :src="rental.listing.img">
                </div>
                <h6 class="w-100 w-50-m">{{rental.listing.title}}</h6>
            </div>
        </router-link>
        
    </div>
</template>

<script>
export default {
    props: {
        rentals: {
            type: Array,
            required: true
        }
    }
};
</script>
